const LANGUAGES = {
  ENGLISH: 'en',
  GERMAN: 'de',
} as const

export default LANGUAGES
